import { NgModule, Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { InteractiveContainer  } from '../interactive-container.component';
import { InteractiveComponent } from '../interactive.component';
import { StaticContainer } from '../static-container.component';
import { OnScreenComponent } from '../on-screen/on-screen.component';
import { SVG } from '../svg/svg.component';
import { DataSourceComponent } from '../data-source.component';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule
    ],
    declarations: [
        StaticContainer,
        InteractiveContainer,
        InteractiveComponent,
        OnScreenComponent,
        SVG,
        DataSourceComponent
    ],
    exports: [
        StaticContainer,
        InteractiveContainer,
        InteractiveComponent,
        OnScreenComponent,
        SVG,
        DataSourceComponent
    ],
    entryComponents: [
        StaticContainer,
        InteractiveContainer,
        InteractiveComponent,
        SVG,
        DataSourceComponent
    ]
})
export class SharedComponentsModule { }


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-component/module/shared-component.module.ts